export default __webpack_public_path__ + "d294ae3712cbf3ee635dc6d2b02c7a86.png";